<template>
    <div id="album-frentes-desktop">
        <v-container
        fluid>

            <v-card
             v-for="frente in album"
            :key="frente.relevancia"

            flat>
            <template
            v-if="verRelevancia(frente.modulos,modulo)=== true">

                <v-card-title class="naranja"
               >{{frente.relevancia.slice(0,130)}}
               </v-card-title>
                <v-list
                flat>
                    <v-list-group
                    :value="false"
                    v-for="item in frente.frentes"
                    :key="item.descripcion"
                    class="base4 font-weight-bold primary--text h2 pa-3"
                    >
                        <template v-slot:activator>
                            <v-list-item-title
                            class="base4 font-weight-bold primary--text h2 pa-4">
                            {{ `${item.descripcion.slice(0,130)}   ` }}
                            <v-chip>{{item.totalImagenes}}</v-chip>
                            </v-list-item-title>
                        </template>

                         <v-row class="bkground font-weight-bold primary--text h2 pa-3">
                            <v-col
                            v-for="img in item.imagenes"
                            :key="img.imagen"
                            class="d-flex child-flex"
                            cols="2"
                            >
                            <v-card style="text-aling:center;" flat>

                                <v-img
                                :src="`${$urlFileServer}/${img.imagen}/thumbnail`"
                                :lazy-src="`${$urlFileServer}/${img.imagen}/thumbnail`"
                                aspect-ratio="1"
                                max-height="100"
                                max-width="100%"
                                class="grey lighten-2"
                                @click="clickMostrarVentanaZoomImagen(item.imagenes, img.imagen)"
                                style="cursor: pointer;"
                                >
                                    <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-progress-circular
                                        indeterminate
                                        color="grey lighten-5"
                                        ></v-progress-circular>
                                    </v-row>
                                    </template>

                                </v-img>

                            <v-card-subtitle class="secondary--text pa-1">
                            <v-row  class="hidden-md-and-down">
                                <v-col class="d-flex justify-space-between">
                                <v-chip color="base5" class="primary--text pa-4">
                                {{ new Date(`${img.fecha} 00:00:0`).toLocaleDateString('es-MX') }}
                                </v-chip>

                                <v-spacer></v-spacer>

                                <v-tooltip bottom color="verde2" >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="secondary--text"
                                        @click="descargarImagen(img.imagen,
                                        img.frente.slice(0,50), img.fecha, frente.relevancia)"
                                        icon
                                        :loading="mostrarDescargando
                                        && (imagenSeleccionDescarga === img.imagen)"
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                        <v-icon color="blue darken-1">
                                            mdi-cloud-download
                                        </v-icon>
                                    </v-btn>
                                    </template>
                                <span style="color:primary;">Descargar esta foto</span>
                                </v-tooltip>
                                </v-col>
                            </v-row>
                            </v-card-subtitle>

                            </v-card>
                            </v-col>
                        </v-row>

                    </v-list-group>
                </v-list>
                </template>
            </v-card>

        </v-container>

        <!--Ventana Zoom Imagenes-->
        <v-dialog
        ref="ventanaAlbumZoomImagen"
        v-model="mostrarVentanaZoomImagen"
        width="55%"
        heigth= "30%"
        persistent
        >
            <v-card>
                <v-card-title class="secondary--text">
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="cerrar">
                        <v-icon class="secondary--text" large>highlight_off</v-icon>
                    </v-btn>
                </v-card-title>

                <v-carousel
                    hide-delimiter-background
                    show-arrows-on-hover
                    >
                    <v-carousel-item
                        v-for="i in imagenesZoom"
                        :key="i.imagen"
                        :src="`${$urlFileServer}/${i.imagen}`"
                        :lazy-src="`${$urlFileServer}/${i.imagen}`"
                        max-width="100%"
                        max-heigth="100%"
                        contain
                        aspect-ratio="16/9"
                        reverse-transition="fade-transition"
                        transition="fade-transition"
                    >
                    <v-row
                        class="fill-height"
                        justify="center"
                    >
                        <div class="text-h6 center">
                            {{ new Date(`${i.fecha} 00:00:0`).toLocaleDateString('es-MX') }}
                        </div>
                    </v-row>
                    </v-carousel-item>
                </v-carousel>
            </v-card>
        </v-dialog>

    </div>
</template>
<script>
import mixDescargaImagen from '@/helpers/mixDescargaImagen';

export default {
  name: 'AlbumFrentesDesktop',
  props: {
    modulo: {
      type: String,
      required: true,
    },
    numeroContrato: {
      type: String,
      required: false,
      default: 'SinNumeroContrato',
    },
    album: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      mostrarVentanaZoomImagen: false,
      imagenSeleccionDescarga: '',
      mostrarDescargando: false,
      imagenesZoom: [],
    };
  },
  mixins: [
    mixDescargaImagen,
  ],
  methods: {
    verRelevancia(modulosRelevancia, modulo) {
      return modulosRelevancia.some((modulos) => modulos === modulo);
    },
    descargarImagen(imagen, frente, fecha, relevancia) {
      this.imagenSeleccionDescarga = imagen;
      const nombreArchivo = `${this.numeroContrato}_${relevancia}-${frente}-${fecha}`;
      const data = { publicKey: imagen, nombreArchivo };
      this.mixDescargarImagen(data);
    },
    clickMostrarVentanaZoomImagen(imagenesCarrete, imagen) {
      const imagenes = imagenesCarrete.slice();
      const imagenSelect = imagenes.findIndex((i) => i.imagen === imagen);
      const ordenImagenesUno = imagenes.slice(imagenSelect, imagenes.length);
      const ordenImagenesDos = imagenes.slice(0, imagenSelect);
      this.imagenesZoom = [...ordenImagenesUno, ...ordenImagenesDos];
      this.mostrarVentanaZoomImagen = !this.mostrarVentanaZoomImagen;
    },
    cerrar() {
      this.imagenesZoom = [];
      this.mostrarVentanaZoomImagen = !this.mostrarVentanaZoomImagen;
    },
  },
};
</script>
